import moment from "moment";


export default {
  data() {
    return {
      pagination: {},
      search: "",
      searchActive: false,
      currentPage: 1,
      loading: false,
      totalItems: 0,
      items: [],
      itemPerPage: 14,
      dates: [new Date(), new Date()],
      filter: {},
      footer_props: {
        itemsPerPageOptions: [14, 50, 100],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-less-than',
        nextIcon: 'mdi-greater-than',
        itemsPerPageText: this.$t('label.rowPerPage')
      },
      shortcuts: [{
          text: this.$t("picker.today"),
          onClick() {
            return [new Date(), new Date()];
          },
        },
        {
          text: this.$t("picker.yesterday"),
          onClick() {
            const f = moment().subtract(1, "day").startOf("day").toDate();
            const e = moment().subtract(1, "day").endOf("day").toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.currentWeek"),
          onClick() {
            const f = moment().startOf("week").isoWeekday(1).toDate();
            const e = moment().toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.previousWeek"),
          onClick() {
            const f = moment().subtract(1, "week").startOf("week").isoWeekday(1).toDate();
            const e = moment().subtract(1, "week").endOf("week").toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.currentMonth"),
          onClick() {
            const f = moment().startOf("month").toDate();
            const e = moment().toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.previousMonth"),
          onClick() {
            const f = moment().subtract(1, "months").startOf("month").toDate();
            const e = moment().subtract(1, "months").endOf("month").toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.fromPreviousMonth"),
          onClick() {
            const f = moment().subtract(1, "months").startOf("month").toDate();
            const e = moment().toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.fromStartYear"),
          onClick() {
            const f = moment().startOf("year").toDate();
            const e = moment().toDate();
            return [f, e];
          },
        },
      ],

    }
  }
}